// extracted by mini-css-extract-plugin
module.exports = {"offers":"styles-module--offers--37Ttl"};